export const Colors = {
  primary: {
    main: '#008FFF',
    dark: '#0064CB',
    light: '#E5EFFA',
    focusRing: 'rgba(0, 143, 255, 0.08)'
  },

  text: {
    primary: '#102A56',
    label: '#1B365D',
    placeholder: '#91A4BD'
  },

  border: {
    input: '#B8CCE4',
    inputHover: '#7EAFE3',
    divider: '#D8E0EA'
  },

  error: {
    light: '#FF6E00',
    dark: '#C43D00',
    red: 'rgb(196, 61, 0)'
  },

  secondary: '#071270',
  moneyGreen: '#2E7D32',

  black: '#0e0e0e',
  gray1: '#707070',
  gray2: '#DFDFDF',
  gray3: '#F2F2F2',

  white: '#FFF'
} as const;
